import {
  Axios,
  creatorPath,
  grantIdPath,
  recipientPayload,
} from "./accessServiceUtils";

const base = (username) => `${creatorPath(username)}/streams/access`;

const grants = (username) => `${base(username)}/grants`;

export const creatorStreamAccessService = {
  contentType: "stream",
  itemsKey: "streams",
  grantIdsKey: "streamSessionIds",

  getOptions: (username, config = {}) =>
    Axios.get(`${base(username)}/options`, config),

  getGrants: (username, config = {}) => Axios.get(grants(username), config),

  saveGrant: (username, form, editingGrantId = null) => {
    const payload = {
      ...recipientPayload(form),

      streamSessionIds: form.accessScope === "selected" ? form.selectedIds : [],
    };

    if (editingGrantId == null) {
      return Axios.post(grants(username), payload);
    }

    const { accessScope, expiresAt, streamSessionIds } = payload;

    return Axios.put(`${grants(username)}/${grantIdPath(editingGrantId)}`, {
      accessScope,
      expiresAt,
      streamSessionIds,
    });
  },

  revokeGrant: (username, grantId) =>
    Axios.post(`${grants(username)}/${grantIdPath(grantId)}/revoke`),
};
